<template>
  <v-snackbar v-model="show" color="green" timeout="10000" multi-line bottom>
    Calculating Deck Space
    <template v-slot:action="">
      <v-progress-circular indeterminate></v-progress-circular>
    </template>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'CalculatingDeckSpaceNotification',
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapState(['voyageReportsStore']),
    deckSpaceCalculating() {
      return this.voyageReportsStore ? this.voyageReportsStore.isCalculatingDeckSpace : false;
    },
  },
  watch: {
    deckSpaceCalculating(newValue) {
      if (newValue === true) {
        this.show = true;
      } else {
        setTimeout(() => {
          this.show = false;
        }, 2000);
      }
    },
  },
};
</script>
